/**
 * Utility functions for handling tenant-specific configurations
 */

export type Tenant =
  | 'homebrew'
  | 'core'
  | 'cpf'
  | 'csc'
  | 'psfa'
  | 'scs'
  | 'gdad'
  | 'reward'
  | 'disposal'
  | 'rpalogin'
  | 'dcat'
  | 'tableau'
  | 'invite'
  | 'bedrock'
  | 'gfie'
  | 'secondments';
const validTenants = new Set<Tenant>([
  'homebrew',
  'core',
  'cpf',
  'csc',
  'psfa',
  'scs',
  'gdad',
  'reward',
  'disposal',
  'rpalogin',
  'dcat',
  'tableau',
  'invite',
  'bedrock',
  'gfie',
  'secondments',
]);

export const isValidTenant = (value?: string | null): value is Tenant => {
  if (!value) return false;
  return validTenants.has(value as Tenant);
};

/**
 * Extracts tenant from URL path
 * @param pathname - The URL pathname
 * @returns The tenant identifier or null if not found
 */
export const getTenantFromPath = (pathname: string): Tenant | null => {
  const pathParts = pathname.split('/').filter(Boolean);
  const firstSegment = pathParts[0];
  return isValidTenant(firstSegment) ? firstSegment : null;
};
